// extracted by mini-css-extract-plugin
module.exports = {"wya20fe":"wya20fe","i1frud41":"i1frud41","o11qe2cf":"o11qe2cf"};